import { makeStyles } from '@material-ui/core/styles';


export const GraficasStyles = makeStyles((theme) => ({
  title: {
    marginTop: '3%',
    textAlign: 'center',
    marginBottom: '2%',
    fontSize: '25px',
    fontWeight: 'bold',
    fontFamily: "'Segoe UI Variable Static Display 700', sans-serif",

  },
  card: {
    padding: theme.spacing(3),
    boxShadow: '0px 0px 6px rgba(0, 0, 0, 0.2)', // Aquí definimos la sombra
    borderRadius: '10px',
    height: '200px',
    marginTop: '0%',
    marginBottom: '3.2%',
    alignItems: 'center'
  }
}));